import * as React from "react";

export const TriggerOktaSignInPage: React.FunctionComponent = () => {
    return <div>
        Triggers okta sign in page
    </div>;
};